<script>
  import TryButton from '$lib/TryButton.svelte'
  import WatchDemoButton from '$lib/WatchDemoButton.svelte'
  import { fade } from 'svelte/transition'
</script>

<section class="py-16">
  <div class="container mx-auto px-4 md:px-16 lg:px-24">
    <div class="flex flex-col justify-center items-center max-w-4xl mx-auto text-center mb-12">
      <h2 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" in:fade={{ duration: 300, delay: 150 }}>
        <span class="text-am-white-60 block">AddMeetings</span>
        <span class="text-am-black">For Sellers</span>
      </h2>

      <p class="text-am-black-75 text-lg mb-8 max-w-2xl" in:fade={{ duration: 300, delay: 300 }}>
        Connect with the right decision-makers, pitch smarter, and close more deals without the noise of cold outreach.
      </p>

      <div class="flex flex-col sm:flex-row justify-center gap-4" in:fade={{ duration: 300, delay: 450 }}>
        <TryButton>Try for Free</TryButton>
        <WatchDemoButton href="https://youtu.be/7gSFB1X--88" />
      </div>
    </div>

    <div
      class="w-full mx-auto rounded-2xl overflow-hidden aspect-video mt-8 max-h-[90vh]"
      in:fade={{ duration: 300, delay: 600 }}
    >
      <img src="/main-pointing-at-laptop.jpeg" alt="Mature businessman in an office setting" class="w-full h-auto" />
    </div>
  </div>
</section>
